declare namespace $ {

	type $mol_view__event_shm_hitalama_app_fullscreen_1 = $mol_type_enforce<
		({ 
			scroll( next?: ReturnType< $shm_hitalama_app_fullscreen['group_scroll'] > ): ReturnType< $shm_hitalama_app_fullscreen['group_scroll'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_app_fullscreen_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_app_fullscreen extends $mol_view {
		fullscreen_widget_toggle_auto( ): any
		group_scroll( next?: any ): any
		Group_space( ): $mol_view
		Group_scroll( ): $mol_view
		Group_back( ): $mol_view
		Group_fill( ): $mol_view
		fullscreens( ): readonly(any)[]
		display( ): string
		map_book( ): $shm_hitalama_map_book
		overlay_panel( ): $shm_hitalama_app_overlay
		auto( ): readonly(any)[]
		sub( ): readonly(any)[]
		style( ): ({ 
			'display': ReturnType< $shm_hitalama_app_fullscreen['display'] >,
		})  & ReturnType< $mol_view['style'] >
	}
	
}

//# sourceMappingURL=fullscreen.view.tree.d.ts.map